// import Vue from 'vue'
// import Router from 'vue-router'
import HelloWorld from '../login.vue'

// Vue.use(Router)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }
  ]
})
